import React from 'react';
import { Col, ControlLabel, Row, InputGroup } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import constants from '../util/constants';
import wrapWithApiData from '../wrapWithApiData';
import NPPanel from '../NPPanel';
import ReactGA from 'react-ga';
import './style.scss';


const { API_BASE_URL } = constants;

class Profile extends React.Component {
  constructor(props) {
    super(props);

    this.getCustomerData = this.getCustomerData.bind(this);
    this.getCustomerName = this.getCustomerName.bind(this);
    this.changeLegalEntity = this.changeLegalEntity.bind(this);

    this.propertyMap = {
      CLIENT_CODE_REGIONAL: "Customer no",
      MARKET_AREA_CODE: "Area Sales Director",
      COMPANY: "Company",
      SHORT_NAME: "Short name",
      REGISTRATION_NUMBER1: "Registration number",
      CURRENCY_CODE: "Currency",
      LANGUAGE_CODE: "Language",
      TERMS_OF_PAYMENT_CODE: "Terms of payment",
      DELIVERY_CODE: "Delivery",
      EMAIL: "Email",
      PHONE: "Phone",
      PHONE2: "Phone2"
    }

    this.propertyMapUser = {
      USER_ID: "User ID",
      SHORT_NAME: "Name",
      CLIENT_CODE_REGIONAL: "Customer no",
      MARKET_AREA_CODE: "Market area",
      MILL_CODE: "Mill code",
      COUNTRY_CODE: "Country",
      LANGUAGE_CODE: "Language",
      EMAIL: "Email",
      PHONE: "Phone",
      TwoFactorPhonenumber: "TwoFactor phone"
    }

    this.state = { 
                customerData: '', 
                userData: '',  
                entities: [],
                entity: '',
                successMessage: 'Legal Entity updated.',
                success: false,
                errorMessage: '',
                showError: false,
                standards: [],
                standard: ''
    };
    this.getData();
  }

  getData()  {
    let self=this;
    const header = {
      'Authorization': 'Bearer ' + this.props.apiToken,
      'Accept': 'application/octet-stream'
    };
    axios.get(API_BASE_URL + 'Dashboard/GetCustomerData', { headers: header })
    .then(result => {

      //
      // J_W : Refactor (Note 1.)
      //

      let current_standard
      if (window.sessionStorage.getItem('UnitConversion') === "IMPERIAL") {
        current_standard = 'IMPERIAL';
      } else {
        current_standard = "METRIC";
      } 
      
      self.setState({standard: {
        label: current_standard, 
        value: window.sessionStorage.getItem('UnitConversion')
      }});

      self.setState({standards: [
        {label: 'METRIC', value: "METRIC"},
        {label: 'IMPERIAL', value: "IMPERIAL"}
      ]});

      if(result.data.INTERNAL){
          self.setState({ userData: result.data, entity: { label: result.data.LEGAL_ENTITY, value: result.data.LEGAL_ENTITY }});
      }
      else{
        self.setState({customerData: result.data});
      }
      let ent = ['NP', 'NPBA'];
        self.setState({
            entities: ent.map(x => {
                return { label: x, value: x }
            })
        });
    }
    );
  }
  
  changeLegalEntity(item){
    const header = {
      'Authorization': 'Bearer ' + this.props.apiToken,
      'Accept': 'application/octet-stream'
    };
    let self = this;
    axios.get(API_BASE_URL + `Account/UpdateLegalEntity/?entity=${item.value}`, { headers: header })
        .then(response => {
            let data = response.data;
            self.setState({ showError: false, success: true, entity: item }, () => {
                console.log(this.state.entities, this.state.entity);

            });
            window.sessionStorage.setItem('LegalEntity', data);
            self.props.refreshHeaderFilter();
            this.GAtrackHandler(item);
        })
        .catch(error => {
            let data = error.response.data;
            self.setState({showError: true, success: false, errorMessage: data.Message});
        });
  }

  changeUnitConversion(item){
    const header = {
      'Authorization': 'Bearer ' + this.props.apiToken,
      'Accept': 'application/octet-stream'
    };
    let self = this;
    axios.get(API_BASE_URL + `Account/UpdateStandard/?standard=${item.value}`, { headers: header })
        .then(response => {
            let data = response.data;
            self.setState({ showError: false, success: true, standard: item }, () => {
            });
            
            window.sessionStorage.setItem('UnitConversion', data);
            self.props.refreshHeaderFilter();
            this.GAtrackHandler_Standard(item);
        })
        .catch(error => {
          let data = error.response.data;
          self.setState({showError: true, success: false, errorMessage: data.Message});
      });
  }
  
  getCustomerName() {
    if(this.state.customerData != undefined) {
      return this.state.customerData.COMPANY || ''
    }
  }

  getCustomerData() {

    if (this.state.customerData != undefined && this.state.customerData.INTERNAL != undefined) {
      const customer = this.state.customerData;
      const content = [];
      for (let prop in customer) {
        if (customer.hasOwnProperty(prop) && this.propertyMap.hasOwnProperty(prop)) {
          content.push(
            <Row key={prop}>
              <Col sm={3} componentClass={ControlLabel}>
                {this.propertyMap[prop]}:
              </Col>

              <Col sm={6}>
                {customer[prop]}
              </Col>
            </Row>
          )
        }
      }
      return content;
    } 
    else if (this.state.userData != undefined && this.state.userData.INTERNAL != undefined){
      const user = this.state.userData;
      const content = [];
      for (let prop in user) {
        if (user.hasOwnProperty(prop) && this.propertyMapUser.hasOwnProperty(prop)) {
          content.push(
            <Row key={prop}>
              <Col sm={3} componentClass={ControlLabel}>
                {this.propertyMapUser[prop]}:
              </Col>

              <Col sm={6}>
                {user[prop]}
              </Col>
            </Row>
          )
        }
      }

      content.push(
        <Row key={'LEGAL_ENTITY'}>
          <Col sm={3} componentClass={ControlLabel}>
            Legal entity:
          </Col>

          <Col sm={6}>
            <InputGroup className="margin-left-5 margin-top-3 mb-3 profile" size="sm">
                <Select isSearchable={true} isClearable={false} resetValue='' style={{ width: '80px', zIndex: 10 }}
                    isDisabled={false}
                    styles={{
                        valueContainer: (provided) => ({
                            ...provided,
                            minWidth: '100px'
                        })
                    }}
                    defaultValue={this.state['entity']} onChange={(item) => this.changeLegalEntity(item, 'entity')}
                    options={this.state.entities} placeholder={'Legal entity'} />
            </InputGroup>
          </Col>
        </Row> 
      )
      return content;
    }
    else {
      return null;
    }
  }

  GAtrackHandler(e) {
    ReactGA.event({
      category: "User action",
      action: "Leagal entry changed to "+ e.value,
    });  
  }

  GAtrackHandler_Standard(e) {
    ReactGA.event({
      category: "User action",
      action: "Standard entry changed to "+ e.value,
    });  
  }

  render() {
    return (
      <NPPanel title={this.getCustomerName()} small centered>
        <Col sm={12} md={12}>
          {this.getCustomerData()}
          <Row key={'CHOOSE_STANDARD'}>
          <Col sm={3} componentClass={ControlLabel}>
            Choose Standard:
          </Col>
          <Col sm={6}>
            <InputGroup className="margin-left-5 margin-top-3 mb-3 profile" size="sm">
                <Select isSearchable={true} isClearable={false} resetValue='' style={{ width: '80px', zIndex: 10 }}
                    isDisabled={false}
                    styles={{
                        valueContainer: (provided) => ({
                            ...provided,
                            minWidth: '100px'
                        })
                    }}
                    value={this.state.standard} onChange={(item) => this.changeUnitConversion(item, 'standard')}
                    options={this.state.standards} placeholder={'Choose standard'} />
            </InputGroup>
          </Col>
        </Row>
        </Col>
        {this.state.success &&
          <div>
          <label>{this.state.successMessage}</label>
          </div>
        }  
        {this.state.showError &&
          <div>
          <label className="danger">Error: {this.state.errorMessage}</label>
          </div>
        }  
      </NPPanel>
    )
  }
}

export default wrapWithApiData({
  customerData:  {url: 'Dashboard/GetCustomerData'},
}, Profile);